import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Mar 06 2019
 * @author SKu
 */
import { Utils } from '@logio/common-be-fe';
import * as React from 'react';
import FormGroup from '../../../../forms/FormGroup/FormGroup';
import translate from '../../../../i18n/translate';
import CheckBoxGroup from '../../../../inputs/CheckBoxGroup';
import Input from '../../../../inputs/Input';
import Label from '../../../../typography/Label';
import Filter from './Filter';
import FilterWrapper from './FilterWrapper';
import RadioGroup from '../../../../inputs/RadioGroup';
/**
 * Filter selecting number interval
 */

var ReferencePriceFilter =
/*#__PURE__*/
function (_Filter) {
  _inherits(ReferencePriceFilter, _Filter);

  function ReferencePriceFilter() {
    var _this;

    _classCallCheck(this, ReferencePriceFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReferencePriceFilter).apply(this, arguments));
    _this.state = {
      from: '',
      to: '',
      alerts: ['true', 'false'],
      valueType: ''
    };
    /**
     * Sets input values
     * @param event Input's event object
     * @param results Validation results
     */

    _this.onChange = function (event) {
      if (_this.state[event.target.name] !== event.target.value) {
        if (event.target.name === 'from') {
          _this.setState({
            from: event.target.value,
            valueType: 'with-value'
          }, _this.props.filterChangedCallback);
        }

        if (event.target.name === 'to') {
          _this.setState({
            to: event.target.value,
            valueType: 'with-value'
          }, _this.props.filterChangedCallback);
        }
      }
    };

    _this.onCheckBoxGroupChange = function (alerts) {
      return _this.setState({
        alerts: alerts,
        valueType: 'with-value'
      }, _this.props.filterChangedCallback);
    };

    _this.onRadioGroupChange = function (valueType) {
      if (valueType === 'blank') {
        _this.setState({
          from: '',
          to: '',
          alerts: [],
          valueType: valueType
        }, _this.props.filterChangedCallback);
      } else {
        _this.setState({
          from: '',
          to: '',
          valueType: valueType,
          alerts: ['true', 'false']
        }, _this.props.filterChangedCallback);
      }
    };
    /**
     * Resets input values and clears filter
     */


    _this.onClear = function () {
      _this.setState({
        from: '',
        to: '',
        alerts: ['true', 'false'],
        valueType: ''
      }, _this.closePopup);
    };

    return _this;
  }
  /**
   * This function determines whether column's filter is active
   */


  _createClass(ReferencePriceFilter, [{
    key: "isFilterActive",
    value: function isFilterActive() {
      return this.state.from !== null && this.state.from !== undefined && !Utils.isEmptyString(this.state.from) || this.state.to !== null && this.state.to !== undefined && !Utils.isEmptyString(this.state.to) || this.state.alerts !== null && this.state.alerts !== undefined && this.state.alerts.length < 2 || this.state.to !== null && this.state.to !== undefined && !Utils.isEmptyString(this.state.valueType);
    }
    /**
     * This function determines whether each node passes the filter
     * In case of tree view this applies only from the lowest level
     * If there's a children matching filter, parent gets displayed even if it doesn't pass itself
     */

  }, {
    key: "doesFilterPass",
    value: function doesFilterPass(params) {
      var price = this.props.valueGetter(params.node);
      var valueFilterConditions = {
        from: true,
        to: true,
        alerts: true,
        valueType: true
      };

      if (this.state.valueType === 'with-value') {
        if (!Utils.isEmptyString(this.state.from)) {
          valueFilterConditions.from = !Utils.isValueMissing(price) && !Utils.isValueMissing(price.value) && Number(price.value) >= Number(this.state.from);
        }

        if (!Utils.isEmptyString(this.state.to)) {
          valueFilterConditions.to = !Utils.isValueMissing(price) && !Utils.isValueMissing(price.value) && Number(price.value) <= Number(this.state.to);
        }

        if (this.state.alerts.length !== 0) {
          valueFilterConditions.alerts = !Utils.isValueMissing(price) && (this.state.alerts.includes('false') && (Utils.isValueMissing(price.messages) || price.messages.size === 0) || this.state.alerts.includes('true') && !Utils.isValueMissing(price.messages) && price.messages.size > 0);
        }

        if (this.state.alerts.length === 2 && Utils.isEmptyString(this.state.to) && Utils.isEmptyString(this.state.from)) {
          valueFilterConditions.valueType = !Utils.isValueMissing(price) && (!Utils.isValueMissing(price.value) || !Utils.isValueMissing(price.messages) && price.messages.size > 0);
        }
      }

      if (this.state.valueType === 'blank') {
        valueFilterConditions.valueType = Utils.isValueMissing(price) || Utils.isValueMissing(price.value) && Utils.isValueMissing(price.messages);
      }

      return Object.values(valueFilterConditions).every(function (c) {
        return c;
      });
    }
    /**
     * This function is for getColumnState() output and similar
     */

  }, {
    key: "getModel",
    value: function getModel() {
      return {
        from: this.state.from,
        to: this.state.to,
        alerts: this.state.alerts,
        valueType: this.state.valueType
      };
    }
    /**
     * This function set filter state from setColumnState() input and similar
     * @param model data input
     */

  }, {
    key: "setModel",
    value: function setModel(model) {
      this.setState({
        from: model ? model.from : '',
        to: model ? model.to : '',
        alerts: model ? model.alerts : ['true', 'false'],
        valueType: model ? model.valueType : ''
      }, this.props.filterChangedCallback);
    }
    /**
     * Updates filter if value in floating filter changes
     * @param model object with filter state
     */

  }, {
    key: "onFloatingFilterChanged",
    value: function onFloatingFilterChanged(model) {
      if (!model) {
        this.setState({
          from: '',
          to: '',
          alerts: ['true', 'false'],
          valueType: ''
        }, this.props.filterChangedCallback);
      } else {
        this.setState({
          from: model.from,
          to: model.to,
          alerts: model.alerts,
          valueType: model.valueType
        }, this.props.filterChangedCallback);
      }
    }
    /**
     * Renders filter component
     */

  }, {
    key: "render",
    value: function render() {
      return React.createElement(FilterWrapper, {
        onApply: this.onApply,
        onClear: this.onClear
      }, React.createElement(FormGroup, {
        noLabel: true
      }, React.createElement(RadioGroup, {
        value: this.state.valueType,
        typeButton: true,
        tinyButton: true,
        name: "final-price-radiogroup-filter",
        options: [{
          label: translate('filter-with-value'),
          value: 'with-value'
        }, {
          label: translate('filter-blank'),
          value: 'blank'
        }],
        onChange: this.onRadioGroupChange
      })), React.createElement(FormGroup, null, React.createElement(Label, null, "From:"), React.createElement(Input, {
        type: "number",
        tiny: true,
        name: "from",
        value: this.state.from,
        onChange: this.onChange
      })), React.createElement(FormGroup, null, React.createElement(Label, null, "To:"), React.createElement(Input, {
        type: "number",
        tiny: true,
        name: "to",
        value: this.state.to,
        onChange: this.onChange
      })), React.createElement(FormGroup, {
        noLabel: true
      }, React.createElement(CheckBoxGroup, {
        values: this.state.alerts,
        groupLabel: translate('alerts-filter'),
        name: "price-change-index-checkboxgroup-filter",
        options: [{
          label: translate('alerts-true'),
          value: 'true'
        }, {
          label: translate('alerts-false'),
          value: 'false'
        }],
        onChange: this.onCheckBoxGroupChange
      })));
    }
  }]);

  return ReferencePriceFilter;
}(Filter);

export { ReferencePriceFilter as default };